export enum UserMySalesPositions {
  UserArtworkAdd = 'userArtworkAdd',
  UserDataForPayouts = 'userDataForPayouts',
  UserSalesList = 'userSalesList',
  UserSoldArtworks = 'userSoldArtworks'
}
